import styled from '@emotion/styled';
import { SMagicBox } from '@shared/styles/styledComponentsCommon';

export const SSMagicBox = styled(SMagicBox)`
  width: 100%;
  min-width: 0;
`;
